export const SNMP_CONFIGURATION_SECTION_EVENT =
	'canvas-agent:snmp-configuration:section';
export const SNMP_CONFIGURATION_FOCUS_EVENT =
	'canvas-agent:snmp-configuration:focus';
export const SNMP_CONFIGURATION_FILTER_EVENT =
	'canvas-agent:snmp-configuration:filter';
export const SNMP_CONFIGURATION_CREATE_MODAL_EVENT =
	'canvas-agent:snmp-configuration:create-modal';
export const SNMP_CONFIGURATION_EDIT_MODAL_EVENT =
	'canvas-agent:snmp-configuration:edit-modal';
export const SNMP_CONFIGURATION_DELETE_MODAL_EVENT =
	'canvas-agent:snmp-configuration:delete-modal';
